import React from "react";

// Compact payment method logos. Rendered as inline SVGs so they render crisp
// at any size. Colors are simplified brand-inspired versions.

export const VisaLogo = ({ height = 20 }) => (
  <svg viewBox="0 0 60 20" style={{ height }} className="w-auto" aria-label="Visa">
    <text x="0" y="16" fontFamily="Arial, sans-serif" fontWeight="900" fontSize="18" fontStyle="italic" fill="#1a1f71" letterSpacing="1">VISA</text>
  </svg>
);

export const MastercardLogo = ({ height = 22 }) => (
  <svg viewBox="0 0 40 24" style={{ height }} className="w-auto" aria-label="Mastercard">
    <circle cx="15" cy="12" r="9" fill="#eb001b" />
    <circle cx="25" cy="12" r="9" fill="#f79e1b" />
    <path d="M20 5.5 a9 9 0 0 1 0 13 a9 9 0 0 1 0 -13z" fill="#ff5f00" />
  </svg>
);

export const AmexLogo = ({ height = 20 }) => (
  <svg viewBox="0 0 60 20" style={{ height }} className="w-auto" aria-label="American Express">
    <rect width="60" height="20" rx="3" fill="#016fd0" />
    <text x="30" y="9" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="5" fill="#fff" textAnchor="middle" letterSpacing="0.5">AMERICAN</text>
    <text x="30" y="16" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="5" fill="#fff" textAnchor="middle" letterSpacing="0.5">EXPRESS</text>
  </svg>
);

export const ApplePayLogo = ({ height = 20 }) => (
  <svg viewBox="0 0 64 24" style={{ height }} className="w-auto" aria-label="Apple Pay">
    {/* Apple */}
    <path d="M12.3 6.5c-.7 0-1.6.5-2.1 1.1-.5.6-1 1.5-.8 2.4.8 0 1.7-.5 2.2-1.1.5-.6.9-1.5.7-2.4z" fill="#000"/>
    <path d="M15.6 17.4c-.4.9-.9 1.7-1.6 2.4-.8.8-1.7 1.2-2.6 1.2-.9 0-1.4-.4-2.5-.4-1.1 0-1.7.4-2.6.4-.9 0-1.7-.4-2.4-1.1-2.1-2.2-2.4-6.6-.4-9 .7-.8 1.7-1.4 2.8-1.4 1 0 1.6.5 2.5.5s1.6-.5 2.7-.5c1 0 2 .5 2.7 1.4-2.4 1.3-2 4.7.4 5.5z" fill="#000"/>
    {/* Pay text */}
    <text x="22" y="18" fontFamily="Arial, Helvetica, sans-serif" fontWeight="700" fontSize="14" fill="#000">Pay</text>
  </svg>
);

export const GooglePayLogo = ({ height = 20 }) => (
  <svg viewBox="0 0 72 24" style={{ height }} className="w-auto" aria-label="Google Pay">
    {/* G */}
    <path d="M11.9 12.2v3.1h4.4c-.2 1-.7 1.9-1.5 2.4-.7.5-1.7.8-2.9.8-2.4 0-4.5-1.6-5.2-3.8-.2-.6-.3-1.2-.3-1.8s.1-1.2.3-1.8c.7-2.2 2.8-3.8 5.2-3.8 1.3 0 2.5.5 3.4 1.3l2.3-2.3C16.1 5 14.2 4.2 11.9 4.2c-3.3 0-6.2 1.9-7.6 4.7-.6 1.1-.9 2.3-.9 3.6s.3 2.5.9 3.6c1.4 2.8 4.3 4.7 7.6 4.7 2.3 0 4.2-.7 5.6-2 1.6-1.5 2.5-3.7 2.5-6.3 0-.6 0-1.1-.1-1.6h-8z" fill="#4285f4"/>
    <text x="24" y="18" fontFamily="Arial, Helvetica, sans-serif" fontWeight="500" fontSize="14" fill="#5f6368">Pay</text>
  </svg>
);

export const NfcLogo = ({ height = 20 }) => (
  <svg viewBox="0 0 26 24" style={{ height }} className="w-auto" aria-label="NFC / Tap to Pay">
    <path d="M6 6c3.5 3 3.5 9 0 12" stroke="#0e2408" strokeWidth="2" fill="none" strokeLinecap="round"/>
    <path d="M10 4c5 4 5 12 0 16" stroke="#0e2408" strokeWidth="2" fill="none" strokeLinecap="round"/>
    <path d="M14 2c6.5 5 6.5 15 0 20" stroke="#0e2408" strokeWidth="2" fill="none" strokeLinecap="round"/>
    <path d="M18 0.5c8 6 8 17 0 23" stroke="#0e2408" strokeWidth="2" fill="none" strokeLinecap="round" opacity="0.5"/>
  </svg>
);

export const AchLogo = ({ height = 20 }) => (
  <svg viewBox="0 0 46 24" style={{ height }} className="w-auto" aria-label="ACH bank transfer">
    {/* Bank building */}
    <polygon points="4,7 11,3 18,7" fill="none" stroke="#0e2408" strokeWidth="1.6" strokeLinejoin="round"/>
    <line x1="4" y1="7" x2="18" y2="7" stroke="#0e2408" strokeWidth="1.6"/>
    <line x1="6" y1="8" x2="6" y2="15" stroke="#0e2408" strokeWidth="1.6"/>
    <line x1="10" y1="8" x2="10" y2="15" stroke="#0e2408" strokeWidth="1.6"/>
    <line x1="12" y1="8" x2="12" y2="15" stroke="#0e2408" strokeWidth="1.6"/>
    <line x1="16" y1="8" x2="16" y2="15" stroke="#0e2408" strokeWidth="1.6"/>
    <line x1="3" y1="16" x2="19" y2="16" stroke="#0e2408" strokeWidth="1.6"/>
    <text x="23" y="16" fontFamily="Arial, sans-serif" fontWeight="800" fontSize="12" fill="#0e2408" letterSpacing="0.5">ACH</text>
  </svg>
);

// A tidy chip that houses a payment logo. Consistent height + white glass tile.
export const PayChip = ({ children, label }) => (
  <div
    className="inline-flex items-center justify-center px-3 py-2 rounded-lg bg-white border border-[#e6e7eb] shadow-sm"
    style={{ minWidth: 62, height: 40 }}
    aria-label={label}
    title={label}
  >
    {children}
  </div>
);
